import { lazy } from 'react';
import { Route } from 'react-router';

import { FRONTEND_ROUTES } from '@/services/Constants';

const ActivityPage = lazy(() => import('../components/ActivityPage'));

export const activityRoutes = () => (
	<Route path={FRONTEND_ROUTES.ACTIVITY} element={<ActivityPage />} />
);
